import React from 'react';

const Services = React.forwardRef((props, ref) => {
  return (
    <section ref={ref} id="servicios" className="relative z-10 bg-white py-20">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-fhk-gray-700 mb-16">
          ¿Qué Ofrecemos?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Vínculo con empresas */}
          <div className="text-center p-6 rounded-2xl bg-fhk-cyan-50 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-fhk-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-fhk-gray-700 mb-3">Vínculo con Empresas</h3>
            <p className="text-fhk-gray-600">Conectamos a nuestras participantes con oportunidades reales de empleo y pasantías.</p>
          </div>

          {/* Comunidad y empleabilidad */}
          <div className="text-center p-6 rounded-2xl bg-fhk-orange-50 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-fhk-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-fhk-gray-700 mb-3">Comunidad y Empleabilidad</h3>
            <p className="text-fhk-gray-600">Red de apoyo mutuo y oportunidades de networking para el desarrollo profesional.</p>
          </div>
        </div>
      </div>
    </section>
  );
});

Services.displayName = 'Services';

export default Services;

